import TemplateView from '../TemplateView'
import {arrayToSet} from '../atUtils'

/**
 * OrderedList allows render ordered list of components and handle items' states changes without rerender.
 * Items order implemented using flex-order on items elements.
 *
 * @state {
 *      items - array of elements
 *      reverseOrder - allows reverse whole list's items order without resetting flex-order styles attribute
 * }
 */
export class OrderedList extends TemplateView {
    constructor({
        itemToComponent = item => null,
        itemToState = item => item,
    }) {
        super()

        this.state = {
            items: [],
            reverseOrder: false
        }

        this.params = {
            itemToComponent,
            itemToState
        }

        this.itemRows = {}

        this.onStatePropertyChanged('items', items => this._updateRows(items))
        this.onStatePropertyChanged('reverseOrder', reverseOrder => this.getEl().toggleClass('reverseOrder', reverseOrder))
    }

    templateHtml() {
        return `<div class='components_orderedList'/>`
    }

    _updateRows(items) {
        const itemsIds = arrayToSet(items.map(f => f.id))

        Object.keys(this.itemRows).filter(id => !itemsIds[id]).forEach(id => {
            this.itemRows[id].getEl().remove()
            delete this.itemRows[id]
        })

        items.forEach((item, index) => {
            if (!this.itemRows[item.id])
                this.itemRows[item.id] = this.params.itemToComponent(item).init(this.getEl())

            this.itemRows[item.id].setState(this.params.itemToState(item))

            this.itemRows[item.id].getEl().css('order', index.toString())
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/components/OrderedList.js